<div *ngIf="shouldShow" class="img-wrapper p-4 flex justify-center items-center">
  <!-- image loading skeleton -->
  <div *ngIf="!logoUrlIsLoaded" class="animated-bg h-full w-full"></div>
  <!-- logoUrl image -->
  <img #img 
    [src]="firstOption || logoUrl" 
    (load)="logoUrlIsLoaded = true"
    [ngStyle]="{'display': logoUrlIsLoaded ? 'block' : 'none' }"
    class="img-card" 
  >
</div>